import React from "react";
import PropTypes from "prop-types";

const onCloseWrapper = ({ _onClose, onClose }) => {
  _onClose();
  if (typeof onClose === "function") {
    onClose();
  }
};

const ModalOverlay = props => {
  const { onClose, _onClose, transparent } = props;

  return (
    <div>
      <div
        onClick={() => onCloseWrapper({ onClose, _onClose })}
        className={`modal-skp__overlay${transparent ? " --transparent" : ""}`}
      />
    </div>
  );
};

ModalOverlay.propTypes = {
  // passed through ModalController
  _onClose: PropTypes.func.isRequired,
  // passed in by alert action caller
  onClose: PropTypes.func,
  transparent: PropTypes.bool
};

ModalOverlay.defaultProps = {
  onClose: null,
  transparent: false
};

export default ModalOverlay;



// WEBPACK FOOTER //
// ./src/components/ModalOverlay/ModalOverlay.js